"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var text_editor_1 = require("../../controls/text-editor");
wp.customize.controlConstructor['epsilon-text-editor'] = wp.customize.Control.extend({
    ready: function () {
        var control = this;
        new text_editor_1.EpsilonTextEditor(control);
        control.container.on('change keyup', 'textarea', function (event) {
            control.setting.set(jQuery(event.target).val());
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/extenders/controls/text-editor.ts
// module id = 21
// module chunks = 0